<div class="align-middle h-full">
    <div [hidden]="!inBeta"
          class="bg-[#EFF4FF] border border-[#C095FF] text-[#764FD4] font-spaceGrotesk font-medium m-[8px] lg:m-[14px] py-[4px] px-[10px] rounded-full cursor-help flex flex-col items-center"
          [matTooltip]="'Kekeno Surveys is in active development, new changes are being released regularly!'">
      <span class="text-[14px] leading-none">Beta</span>
      <span class="text-[10px] opacity-80 leading-none">v{{ version }}</span>
    </div>
</div>
